import { uiText } from '../../i18n/uiText';
import React, { useRef, useState } from 'react';
import api, { getApiErrorMessage } from '../../api';
import useDraftBuffer from '../../hooks/useDraftBuffer';
import FormDraftNotice from '../common/FormDraftNotice';
import { useAuth } from '../../store/AuthContext';

function UserGrants({ target, grants, labels, onSaved, onBusyChange }) {
  const { user } = useAuth();
  const buffer = useDraftBuffer(user.id, target.id, 'qualification-grants');
  const initial = grants.filter(g => g.user_id === target.id).map(g => g.capability).sort();
  const value = buffer.values.form || { expected: initial, capabilities: initial };
  const [busy, setBusy] = useState(false), [error, setError] = useState(''), [saved, setSaved] = useState(false);
  const flight = useRef(false);
  const save = async e => {
    e.preventDefault(); if (flight.current || buffer.recovery) return;
    flight.current = true; setBusy(true); onBusyChange?.(true); setError(''); setSaved(false);
    const snapshot = buffer.snapshot();
    try {
      await api.put('/qualification/grants/batch', { user_id: target.id, ...value });
      buffer.acknowledge(snapshot, { committed: true }); buffer.hydrate({});
      await onSaved(); setSaved(true);
    } catch (e) { setError(getApiErrorMessage(e)); }
    finally { flight.current = false; setBusy(false); onBusyChange?.(false); }
  };
  return <form className="qualification-panel qualification-stack" onSubmit={save}>
    <h3>{target.full_name || target.username}</h3>
    <FormDraftNotice buffer={buffer} label={uiText("Полномочия сотрудника")} disabled={busy} />
    <fieldset className="qualification-grid" disabled={busy || !!buffer.recovery}>
      {Object.entries(labels).map(([code, label]) => <label className="qualification-check" key={code}>
        <input className="ap-check" type="checkbox" checked={value.capabilities.includes(code)} onChange={e => {
          setSaved(false); buffer.edit('form', { ...value, capabilities: e.target.checked ? [...value.capabilities, code] : value.capabilities.filter(c => c !== code) });
        }} />{label}
      </label>)}
    </fieldset>
    {error && <p role="alert" className="qualification-error">{error}</p>}
    <div className="qualification-actions"><button type="submit" className="ap-button ap-button--primary" disabled={busy || !buffer.count || !!buffer.recovery}>{busy ? uiText("Сохраняем…") : uiText("Сохранить полномочия")}</button>
      {buffer.count > 0 && <button type="button" className="ap-button ap-button--secondary" disabled={busy} onClick={() => { buffer.discard(); buffer.hydrate({}); setError(''); }}>{uiText("Отменить изменения")}</button>}
      <span role="status">{saved ? uiText("Полномочия сохранены") : buffer.count ? uiText("Есть несохранённые изменения") : uiText("Изменения применяются после сохранения")}</span>
    </div>
  </form>;
}
export default function QualificationGrants({ users, grants, labels, onSaved, onBusyChange }) {
  return <section className="qualification-stack"><p className="qualification-notice">{uiText("Выберите полномочия сотрудника и нажмите «Сохранить полномочия». Весь набор сохраняется одним действием. Доступ к проведённым аудитам не меняется.")}</p>{users.map(target => <UserGrants key={target.id} target={target} grants={grants} labels={labels} onSaved={onSaved} onBusyChange={onBusyChange} />)}</section>;
}
